import Head from 'next/head'
import { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { MobileHiddenView, MobileOnlyView } from 'components/Media'
import Wallet from 'sections/wallet/Wallet'
import AppLayout from 'sections/shared/Layout/AppLayout'
import { PageContent, MainContent, FullHeightContainer } from 'styles/common'
import PortfolioChart from 'sections/wallet/PortfolioChart'
import { useFetchWalletData } from 'state/wallet/hooks'

type LeaderComponent = FC & { getLayout: (page: ReactNode) => JSX.Element }

const Leader: LeaderComponent = () => {
	const { t } = useTranslation()

	useFetchWalletData()

	return (
		<>
			<Head>
				<title>{t('wallet.page-title')}</title>
			</Head>
			<PageContent>
				<MobileHiddenView>
					<FullHeightContainer>
						<MainContent>
                            <PortfolioChart />
							<Wallet />
						</MainContent>
					</FullHeightContainer>
				</MobileHiddenView>
				<MobileOnlyView>
					<MobileMainContent>
                        <PortfolioChart />
						<br />
						<Wallet mobile />
					</MobileMainContent>
				</MobileOnlyView>
			</PageContent>
		</>
	)
}

const MobileMainContent = styled.div`
	width: 100%;
	padding: 15px;
`

Leader.getLayout = (page) => <AppLayout>{page}</AppLayout>

export default Leader
